import { createContext } from 'react';
import { SMLRouterType } from '../routing/sml/SMLRouterType';

export const RouterContext = createContext<(() => SMLRouterType) | undefined>(undefined);
